export const userTypes = [
  { value: "all", label: "See All" },
  { value: "internal", label: "Internal" },
  { value: "external", label: "External" },
];
